import { FC, Fragment, useCallback, useEffect } from "react";
// i18next
import { useTranslation } from "react-i18next";
// Hooks
import useToggle from "app/hooks/useToggle";
// Redux
import { useAppDispatch, useAppSelector } from "app/hooks/useStore";
// Async
import { createInterimInvoice } from "app/store/BillingInvoices/BillingInvoices.async";
// Actions
import { BillingInvoicesActions } from "app/store/BillingInvoices/BillingInvoices.slice";
// Selectors
import { selectInterimInvoices, selectInterimInvoicesAmount, selectParams } from "app/store/BillingInvoices/BillingInvoices.selectors";
// MUI
import { Box, Typography } from "@mui/material";
// Components
import { Button } from "app/components/Mui";
//
import RequestInterimInvoiceDialog from "../RequestInterimInvoiceDialog";
// Utilities
import { toNumberWithCommas } from "app/utilities/Utilities";

const UpcomingChargeInfo:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const params = useAppSelector(selectParams);
  const interimInvoices = useAppSelector(selectInterimInvoices);
  const interimInvoicesAmount = useAppSelector(selectInterimInvoicesAmount);

  const getData = useCallback(async (caseId:number) => {
    const data = await dispatch(createInterimInvoice({
      data: { caseId },
      params: { dryrun: true }
    })).unwrap();
    dispatch(BillingInvoicesActions.setInterimInvoices(data));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (params.case) {
      getData(params.case.id);
    } else {
      dispatch(BillingInvoicesActions.setInitialField('interimInvoices'));
    }
    // eslint-disable-next-line
  }, [params.case]);

  const { open, toggle } = useToggle();

  if (!interimInvoices || !interimInvoicesAmount) return null;
  return (
    <Fragment>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2
      }}>
        <Typography sx={{ display: 'block' }} variant="subtitle2">
          {t('pages.billingAndSubscriptions.upcomingChargesMessage', { amount: toNumberWithCommas(interimInvoicesAmount) })}
        </Typography>
        <Button
          name="Create interim invoice"
          size="small"
          onClick={toggle}
        >{t('pages.billingAndSubscriptions.createInterimInvoiceButton')}</Button>
      </Box>
      {open && <RequestInterimInvoiceDialog open={open} onClose={toggle} predefinedCase={params.case} initialStep={1} />}
    </Fragment>
  );
};

export default UpcomingChargeInfo;
